'use client';

import { Typography } from 'components';
import { AiStep, AiTypeEnum, Maybe } from 'gql/graphql';
import { useTranslations } from 'next-intl';
import { FC, PropsWithChildren } from 'react';
import GeneralSubStepRun from './GeneralSubStepRun';
import LanguagesStepRun from './LanguagesStepRun';
import ResourcesSubStepsRun from './ResourcesSubStepsRun';

interface AgentStepRun extends AiStep {
  index: number;
  sourceLanguageCode?: Maybe<string>;
  allowPostEditingInfo?: boolean;
}

const AgentStepRun: FC<PropsWithChildren<AgentStepRun>> = ({
  index,
  id,
  type,
  subSteps,
  sourceLanguageCode,
  allowPostEditingInfo = true
}) => {
  const t = useTranslations();

  return (
    <div key={id} className="rounded-5xl border border-tertiary-700 p-2">
      <div className="flex items-center gap-2 border-0 border-b-1 border-tertiary-700 pb-1">
        <span className="!h-[18px] !w-[20px] rounded-10xl bg-primary-blue-100 text-center font-content text-[11px] font-medium leading-[18px] text-white">
          {index + 1}
        </span>
        <Typography variant="regular3" className="w-full text-tertiary-100">
          {t(`agents.agent_builder.edit.steps.${type}.title` as any)}
        </Typography>
      </div>
      {type === AiTypeEnum.Postediting && allowPostEditingInfo && (
        <div className="mt-1">
          <Typography variant="light5" className="mt-4 pt-4 leading-3 text-tertiary-100">
            {t(`agents.agent_builder.edit.steps.postediting.description` as any)}
          </Typography>
        </div>
      )}
      <LanguagesStepRun {...{ subSteps }} sourceLanguageCode={sourceLanguageCode} />
      {subSteps?.map((subStep) => (
        <GeneralSubStepRun key={subStep.id} {...subStep} />
      ))}
      <ResourcesSubStepsRun {...{ subSteps }} />
    </div>
  );
};

export default AgentStepRun;
